module.exports = __webpack_public_path__ + "img/bg-house-blur.3420273.jpg";